import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['link', 'tab']

  openTab({ currentTarget }) {
    let openedTab = null;

    for (let tab of this.tabTargets) {
      if (tab.id === currentTarget.dataset.tab) {
        tab.style.display = 'block';
        openedTab = tab;
      } else {
        tab.style.display = 'none';
      }
    }

    for (let link of this.linkTargets) {
      if (link === currentTarget) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    }

    if (openedTab) {
      requestAnimationFrame(() => {
        const swiperContainers = openedTab.querySelectorAll('.swiper-container');
        swiperContainers.forEach((container) => {
          if (container?.swiper && typeof container.swiper.update === 'function') {
            container.swiper.update();
          }
        });
      });
    }
  }
}